// frontend/src/datahealth/dosTargetFix.js
//
// The `dos_target_below_cycle` rows: where the merchant goes to fix the row.
// The backend decides the level (api.services.data_health — `fix_level`, one
// of api.services.planning_defaults.LEVEL_*); this module only turns it into
// a button label and a destination. An unknown level throws: a row that cannot say
// where its fix is must fail loudly, not send the merchant somewhere plausible.

import { itemsForItemPath } from '../pages/itemSetupLinks';
import { suppliersForSupplierPath } from '../pages/supplierSetupLinks';

// api.services.planning_defaults.LEVEL_*, pinned by the backend's
// api.test_data_health_dos_target_below_cycle (PlanningLevelMirrorTests).
export const PLANNING_LEVELS = ['item_location', 'supplier', 'store'];

function checked(level) {
  if (!PLANNING_LEVELS.includes(level)) {
    throw new Error(`dos_target_below_cycle: unknown planning level ${JSON.stringify(level)}`);
  }
  return level;
}

/** The row's fix button label: "Edit item", "Edit supplier" or "Edit store settings". */
export function dosTargetFixLabelKey(fixLevel) {
  switch (checked(fixLevel)) {
    case 'item_location': return 'dataHealth.editItem';
    case 'supplier': return 'dataHealth.editSupplier';
    default: return 'dataHealth.editStoreSettings';
  }
}

/**
 * The screen the row's fix button opens — Item setup on this item, Supplier
 * setup on the default supplier, or Store settings.
 */
export function dosTargetFixPath(row) {
  switch (checked(row.fix_level)) {
    case 'item_location': return itemsForItemPath(row.item_code);
    case 'supplier': return suppliersForSupplierPath(row.supplier_name);
    default: return '/store-settings';
  }
}
